<template>
  <div>
    <!--图片-->
    <div v-if="imgShow">
      <img :src="downloadUrl" width="100%"/>
    </div>
    <!--doc，excel-->
    <div v-else-if="docShow || excelShow">
      <iframe
        class="child"
        frameborder="0"
        :src="fileUrl"
        :style="{ width: width, height: height }"
      >
      </iframe>
    </div>
    <div v-else-if="pdfShow">
      <PdfViewer :url="downloadUrl"/>
    </div>
    <!--视频-->
    <div v-else-if="videoShow">
      <video preload="auto" :height="height" :width="width" align="center" controls="true" autoplay>
        <source :src="downloadUrl" type="video/mp4" />
      </video>
    </div>
    <!--其他不能预览的-->
    <div v-else-if="otherShow"></div>
  </div>
</template>
<script>
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import PdfViewer from '../../PdfViewer/Index.vue'
import axios from 'axios'

export default {
  components: {
    Video,
    PdfViewer
  },
  props: { file: {} },
  mounted: () => {
    this.baseUrl = process.env.NODE_ENV === 'development' ? 'http://localhost:8082/api' : `http://${window.location.host}/api`
  },
  data () {
    return {
      fileName: '',
      downloadUrl: '',
      imgShow: false,
      docShow: false,
      excelShow: false,
      videoShow: false,
      pdfShow: false,
      // 其他不能预览的
      otherShow: false,
      height: '100%',
      width: '100%',
      baseUrl: '',
      fileUrl: '',
      fileTypeMap: {
        'xls': 'application/vnd.ms-excel',
        'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'doc': 'application/msword',
        'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'pdf': 'application/pdf',
        'ppt': 'application/pdf',
        'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
        'png': 'image/png',
        'gif': 'image/gif',
        'jpeg': 'image/jpeg',
        'jpg': 'image/jpeg',
        'txt': 'text/plain'
      },
      fileType: ''
    }
  },
  created () {
    this.fileName = this.file.fileName// 文件名称（包括后缀名）
    this.downloadUrl = this.file.downloadUrl// 文件路径
    // .png, .jpeg, .jpg,
    // application/pdf, .txt, .xls, .xlsx, .doc, .docx,.ppt, .pptx,
    // .wps, .rtf,.pps, .ppsx,.mp4,.mp3,
    // .zip
    let extentions = this.fileName.substring(this.fileName.lastIndexOf('.') + 1, this.fileName.length)
    this.fileType = this.fileTypeMap[extentions]
    if (this.fileName.endsWith('png') || this.fileName.endsWith('jpg') || this.fileName.endsWith('jpeg')) {
      // 图片
      this.imgShow = true
    } else if (
      this.fileName.endsWith('docx') ||
      this.fileName.endsWith('doc') ||
      this.fileName.endsWith('pptx') ||
      this.fileName.endsWith('ppt') ||
      this.fileName.endsWith('txt')
    ) {
      // window.open(this.downloadUrl)
      // this.showPdf()
      // doc
      this.showFile()
      this.docShow = true
    } else if (this.fileName.endsWith('pdf')) {
      // this.showPdf()
      this.pdfShow = true
    } else if (this.fileName.endsWith('xlsx') || this.fileName.endsWith('xls')) {
      this.showFile()
      this.excelShow = true
    } else if (this.fileName.endsWith('mp4') || this.fileName.endsWith('mp3')) {
      this.videoShow = true
    } else {
      this.otherShow = true
    }
  },
  methods: {
    pdferr () {

    },
    closepdf () {
      this.pdfShow = false
    },
    showFile () {
      axios({
        method: 'get',
        url: this.downloadUrl,
        responseType: 'blob'
      }).then((res) => {
      // loading.close();
        console.log('res', res)
        if (res.status === '500') {
          this.$message({
            message: '下载失败！',
            type: 'error'
          })
          return
        }
        // 文件以pdf形式进行预览application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf
        let blob = new Blob([res.data], {type: this.fileType ? this.fileType : res.data.type})
        let fileURL = window.URL.createObjectURL(blob)
        this.fileUrl = fileURL
      })
      // window.open(this.downloadUrl)
    }
  }
}
</script>
<style scoped>
.child {
  width: 100%;
  height: 100%;
  scrolling: no;
  frameborder: 0;
  border: 0;
  marginwidth: 0;
  marginheight: 0;
}
</style>



// WEBPACK FOOTER //
// src/Views/Project/components/PreviewFile.vue